import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import type { DTOManagementSessionResponse } from 'src/apis/dto/DTOSubscription';
import { client } from 'src/utils/api';

type UseCreateManagementSessionOptions = Omit<
  UseMutationOptions<DTOManagementSessionResponse, Error, string>,
  'mutationFn'
>;

export const useCreateManagementSession = (options?: UseCreateManagementSessionOptions) =>
  useMutation({
    mutationFn: async (subscriptionId: string) => {
      const response = await client.post<DTOManagementSessionResponse>(
        `/api/v1/subscriptions/${subscriptionId}/subscription-management-session`
      );
      return response.data;
    },
    ...options,
  });
